import { Link } from 'react-router-dom';
import { NAV_MENUS, getMegaMenuCols } from './navData';

export default function MegaMenu({ activeMenu, keepMenu, closeMenu }) {
  return (
    <>
      {Object.entries(NAV_MENUS).map(([key, { label, items }]) =>
        activeMenu === key ? (
          <div
            key={key}
            className="absolute top-full left-0 w-full bg-mcx-white border-b border-mcx-mist shadow-xl"
            onMouseEnter={keepMenu}
            onMouseLeave={closeMenu}
            data-testid={`mega-menu-${key}`}
          >
            <div className="max-w-content mx-auto px-6 py-8">
              {NAV_MENUS[key].hubHref ? (
                <Link
                  to={NAV_MENUS[key].hubHref}
                  className="inline-block text-xs font-semibold uppercase tracking-widest text-mcx-signal mb-5 hover:text-mcx-signal-deep"
                  data-testid={`mega-hub-${key}`}
                >
                  {label} &rarr; {NAV_MENUS[key].hubLabel || `See ${label.toLowerCase()}`}
                </Link>
              ) : (
                <p className="text-xs font-semibold uppercase tracking-widest text-mcx-signal mb-5">
                  {label}
                </p>
              )}
              <div className={`grid gap-2 ${getMegaMenuCols(key)}`}>
                {items.map(({ label: iLabel, href, desc }) => (
                  <Link
                    key={href}
                    to={href}
                    className="group p-4 rounded-lg hover:bg-mcx-mist border border-transparent hover:border-mcx-slate/40 transition-all duration-200"
                    data-testid={`mega-link-${href.replace(/\//g, '-').slice(1)}`}
                  >
                    <p className="font-medium text-mcx-ink group-hover:text-mcx-signal transition-colors duration-200 mb-1 text-sm">
                      {iLabel}
                    </p>
                    <p className="text-xs text-mcx-slate leading-snug">{desc}</p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        ) : null
      )}
    </>
  );
}
